import * as React from "react";
import { ViewStyle, TextStyle } from "react-native";
import { useTheme } from "react-native-paper";
import { Text } from "../text/text";
import { Button as PaperButton } from "react-native-paper";
import { ThemeType } from "../../theme/theme";

export enum ButtonVariant {
  LIGHT,
}

export interface ButtonProps {
  text?: string;
  mode?: any;
  style?: ViewStyle;
  variant?: ButtonVariant.LIGHT;
  disabled?: boolean;
  onPress: any;
  loading?: boolean;
  underlined?: boolean;
  children?: any;
  icon?: string;
  iconColor?: string;
  iconSize?: number;
  textStyle?: TextStyle;
  contentStyle?: ViewStyle;
  tx?: string;
  testID?: string;
  accessibilityLabel?: string;
  borderRadius?: number;
}

export const Button = (props: ButtonProps) => {
  let {
    text,
    mode = "text",
    disabled = false,
    loading = false,
    onPress = () => {},
    tx,
    icon,
    iconColor,
    variant,
    children,
    testID,
    accessibilityLabel,
    underlined = false,
    style = {},
    contentStyle = {},
    textStyle = {},
    borderRadius,
    iconSize,
  } = props;

  const theme = useTheme() as ThemeType;
  if (mode === "contained") {
    textStyle = {
      color: theme.colors.white,
      fontSize: theme.fontSize.large,
      textAlign: "center",
      fontWeight: "bold",
      ...textStyle,
    };
    style = {
      ...style,
      borderRadius: 100,
      backgroundColor: !disabled
        ? theme.colors.rebrand.brandOrange
        : theme.colors.rebrand.disabledGrey,
    };
    contentStyle = { ...contentStyle, height: contentStyle.height || 50 };

    if (variant === ButtonVariant.LIGHT) {
      style = {
        backgroundColor: theme.colors.white,
        borderColor: !disabled
          ? theme.colors.rebrand.brandOrange
          : theme.colors.rebrand.disabledGrey,
        borderWidth: 1,
        elevation: 0,
        ...style,
      };
      textStyle = {
        ...textStyle,
        color: !disabled ? theme.colors.white : theme.colors.rebrand.disabledGrey,
      };
    }
  } else {
    textStyle = {
      ...textStyle,
      fontSize: theme.fontSize.large,
      textDecorationLine: underlined ? "underline" : "none",
    };
  }
  const content = children || <Text tx={tx} text={text} style={textStyle} />;
  let otherPaperDefaults = {
    ...(icon ? { icon } : {}),
    ...(iconColor || iconSize ? { labelStyle: { color: iconColor, fontSize: iconSize } } : {}),
    uppercase: false,
    contentStyle,
    style,
  };
  return (
    <PaperButton
      mode={mode}
      theme={theme}
      disabled={disabled}
      onPress={onPress}
      loading={loading}
      testID={testID}
      accessibilityLabel={accessibilityLabel}
      {...otherPaperDefaults}>
      {content}
    </PaperButton>
  );
};
